import { Instagram, Facebook } from "lucide-react";

// TikTok isn't in lucide-react — inline SVG (same 24px viewbox as lucide).
const TikTokIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M16.5 3a5.5 5.5 0 0 0 4.5 5.4v3.03a8.6 8.6 0 0 1-4.5-1.32V15.9A6.1 6.1 0 1 1 10.4 9.8v3.16a3 3 0 1 0 2.94 3v-13H16.5z" />
  </svg>
);

const LINKS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/restaurante_q5/?hl=es", Icon: Instagram },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/people/Restaurante-asiático-Q5/61567973063625/", Icon: Facebook },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@restauranteq5", Icon: TikTokIcon },
];

/**
 * Row of interactive social icons. Two variants:
 * - "square" (default): 40×40 gold-bordered boxes, used in Contact.
 * - "inline": smaller icons for the Footer / Navbar.
 */
export const SocialIcons = ({ variant = "square", size }) => {
  if (variant === "inline") {
    return (
      <div data-testid="social-icons-inline" className="flex items-center gap-3">
        {LINKS.map(({ id, label, href, Icon }) => (
          <a
            key={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`social-${id}`}
            className="text-neutral-500 hover:text-gold transition-colors"
          >
            <Icon size={size || 16} />
          </a>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="social-icons" className="flex items-center gap-3">
      {LINKS.map(({ id, label, href, Icon }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`social-${id}`}
          className="group w-11 h-11 border border-gold/60 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-colors"
        >
          <Icon size={size || 18} className="text-gold group-hover:scale-110 transition-transform" />
        </a>
      ))}
    </div>
  );
};
